import React, { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { FallbackProps } from 'react-error-boundary';
import cx from 'classnames';
import { APP_ROUTES } from '~/routes';
import { Callout } from '@xbto/universal-components';

export const GenericError: FC<
  Partial<FallbackProps & { containerCls?: string }>
> = ({ error, containerCls }) => {
  const navigate = useNavigate();

  const handleOnPress = useCallback(() => {
    navigate(APP_ROUTES.AUTH_PORTFOLIO);
  }, [navigate]);

  /**
   * DOM
   */
  return (
    <div
      className={cx('flex-1 flex justify-center items-center', containerCls)}
    >
      <Callout
        icon="Info"
        variant="tertiary"
        title="Something went wrong"
        message="We couldn’t load this page, please try again later"
        ctas={[
          {
            variant: 'secondary',
            label: 'Back to home page',
            style: { width: 275 },
            onPress: handleOnPress,
          },
        ]}
      >
        {error && <pre className="mt-2 text-grey-darker">{error.message}</pre>}
      </Callout>
    </div>
  );
};
